import {z} from 'zod';

import {refineEmailBody} from '../../../utils/refineEmailBody';

export const SendOnlineOfferEmailFormSchema = z.object({
  contactPerson: z.string(),
  body: refineEmailBody(z.string()),
  emailAddress: z.string().email(),
  smtpCredentialsId: z.string(),
});

export type FormValues = z.infer<typeof SendOnlineOfferEmailFormSchema>;
